import React, { useState } from "react";
import MainContainer from "../../components/app/maincontainer";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
	NewInput,
	// , TextBox
} from "../../components/inputs/main";
import DoneModal from "../../components/modals/donemodal";
import useErrorStore from "../../data/stores/errorStore";
import { toast } from "react-toastify";
import { apiCall } from "../../data/useFetcher";
import { MainBtn } from "../../components/app/buttons";
import { Controller, useForm } from "react-hook-form";

export const removeUndefined = (obj: any) => {
	Object.keys(obj).forEach(
		key => (obj[key] === undefined || !obj[key]) && delete obj[key]
	);
	return obj;
};

const AddRequest = () => {
	const [modal, setModal] = useState(""),
		navigate = useNavigate(),
		[loading, setLoading] = useState(null),
		{ returnErrors } = useErrorStore(),
		{
			control,
			handleSubmit,
			formState: { errors },
		} = useForm({
			defaultValues: {
				organizationName: "",
				description: "",
				contactEmailAddress: "",
				website: "",
			},
		}),
		onSubmit = async (data: any) => {
			// e?.preventDefault();
			setLoading(true);
			let { response, errArr, errMsg } = await apiCall({
				type: "post",
				url: `/api/v1/tools/new-request`,
				data: removeUndefined(data),
			});
			console?.log({ response, errArr, errMsg });
			if (errArr) {
				setLoading(false);
				return returnErrors(errArr);
			}
			if (errMsg) {
				setLoading(false);
				return toast.error(errMsg);
			}
			setLoading(false);
			if (response) {
				navigate(-1);
				return;
			}
			setLoading(false);
		};

	return (
		<div>
			<MainContainer>
				<div className="mt-8 flex justify-between items-center">
					<div className="flex gap-2">
						<FaChevronLeft
							color="#334155"
							onClick={() => navigate(-1)}
							className="cursor-pointer mt-1"
						/>
						<div>
							<h1 className="text-xl font-semibold text-da-blue-600 inter">
								Send New Invite
							</h1>
							<div className="flex gap-2 items-center">
								<span className="text-base font-normal text-[#334155]">
									Invite List
								</span>
								<FaChevronRight color="#334155" size={10} />
								<span className="text-base font-normal text-[#334155]">
									Send New Invite
								</span>
							</div>
						</div>
					</div>
				</div>

				<form
					onSubmit={handleSubmit(onSubmit)}
					className="mt-12 bg-white w-full p-8">
					<div className="mt-6">
						<div className="w-1/2 space-y-5">
							<div>
								<Controller
									name="organizationName"
									control={control}
									rules={{
										required: "This field is required",
									}}
									render={({ field: { value, onChange, name } }) => (
										<NewInput
											type="text"
											name={name}
											value={value}
											label={"Organization Name"}
											onChange={onChange}
											placeholder={"Type the organization name"}
										/>
									)}
								/>
								{errors.organizationName && (
									<p className="text-[#dc2626] text-xs">
										{errors.organizationName.message}
									</p>
								)}
							</div>
							<div>
								<Controller
									name="contactEmailAddress"
									control={control}
									rules={{
										required: "This field is required",
										pattern: {
											value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
											message: "Invalid email format",
										},
									}}
									render={({ field: { value, onChange, name } }) => (
										<NewInput
											type="email"
											name={name}
											value={value}
											label={"Contact Email Address"}
											placeholder={"email address"}
											onChange={onChange}
										/>
									)}
								/>
								{errors.contactEmailAddress && (
									<p className="text-[#dc2626] text-xs">
										{errors.contactEmailAddress.message}
									</p>
								)}
							</div>
							<div className="hidden">
								{/* <div className="grid grid-cols-2 gap-5 mb-4"> */}
								{/* <div>
									<Controller
										name="website"
										control={control}
										rules={{
											required: "This field is required",
											pattern: {
												value:
													/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
												message: "Invalid url format",
											},
										}}
										render={({ field: { value, onChange, name } }) => (
											<NewInput
												type="url"
												name={name}
												value={value}
												label={"Website"}
												placeholder={"Type your website"}
												onChange={onChange}
											/>
										)}
									/>
									{errors.website && (
										<p className="text-[#dc2626] text-xs">
											{errors.website.message}
										</p>
									)}
								</div> */}
							</div>

							{/* <div className="hidden">
								<Controller
									name="description"
									control={control}
									rules={{
										required: "This field is required",
									}}
									render={({ field: { value, onChange, name } }) => (
										<TextBox
											name={name}
											value={value}
											onChange3={onChange}
											label={"Description"}
											placeholder={"Tell us about your tool and company here"}
											setState={(e: any[]) => {
												onChange(e);
											}}
											type="editor"
										/>
									)}
								/>
								{errors.description && (
									<p className="text-[#dc2626] text-xs">
										{errors.description.message}
									</p>
								)}
							</div> */}
						</div>
						<div className="flex mt-9 gap-5">
							<MainBtn
								onClick={() => navigate(-1)}
								className="border border-[#FECACA]"
								text={"Discard"}
								bg={"transparent"}
								color={"#EF4444"}
								type="button"
								disabled={loading}
							/>
							<MainBtn
								text={"Continue"}
								bg={"#3787FF"}
								color={"white"}
								loading={loading}
								type="submit"
							/>
						</div>
					</div>
				</form>
				{modal === "done" && (
					<DoneModal page={"User"} handleClose={() => setModal("")} />
				)}
			</MainContainer>
		</div>
	);
};

export default AddRequest;
